<div *ngIf="isLoading" style="display:flex;">
    <div class="spinner spinner-lg spinner-success"></div>
    <div style="margin-left: 30px;">Kurse prüfen</div>
</div>
<div *ngIf="!isLoading">
    <mat-divider class="p-2 mt-2"></mat-divider>
    <div class="kurse_headerarea">
        <div style="width:50%">
            <div class="headline">Kurse</div>
        </div>
        <div style="width:50%; text-align: right;">
            <div (click)="toggledisplayheight();" matTooltip="aufklappen">
                <div class="btn_expandview"></div>
            </div>
        </div>
    </div>
    <div class="kurse_list">
        <div *ngFor="let kurs of kurse" class="kurs" (click)="onSelectKursItem($event);">            
            <div class="div_kurs" style="font-weight: bold;" data-id={{kurs.id}}>{{kurs.bemerkung}}</div>
            <div class="div_auslastung">                
                <div class="progress-container">                    
                    <span class="tooltiptext">{{ (kurs.kapazitaet - kurs.buchungenAktuell) }} freie Plätze</span>
                    <div class="progress-bar"                    
                        [style.width]="(kurs.buchungenAktuell * 100 / kurs.kapazitaet) < 0 ? '0%' : (kurs.buchungenAktuell * 100 / kurs.kapazitaet) > 100 ? '100%' : (kurs.buchungenAktuell * 100 / kurs.kapazitaet) + '%'"
                        [attr.data-progress]="(kurs.buchungenAktuell * 100 / kurs.kapazitaet) | number: '1.0-0'">
                      
                      <span class="progress-text">
                        {{ (kurs.buchungenAktuell * 100 / kurs.kapazitaet) < 0 ? '0' : (kurs.buchungenAktuell * 100 / kurs.kapazitaet) > 100 ? '100' : (kurs.buchungenAktuell * 100 / kurs.kapazitaet) | number: '1.0-0' }}%
                      </span>
                      
                    </div>
                </div>

            </div> 
            
            

            <div *ngFor="let termin of kurs.termine" style="display: flex;">
                <div class="div_termin" data-id={{termin.id}}>
                    <div><b>von: </b><br>{{termin.beginn | date:'medium'}}</div>
                    <div><b>bis: </b><br>{{termin.ende | date:'medium'}}</div>
                </div>
                <div class="participant_list"></div>
            </div>
        </div>
    </div>
</div>